import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import type { Entity } from '@models/Entity'

import { StyledError } from '../../../../theme/components/StyledError'
import { useCancelBijlageForEntity } from '../../hooks/useCancelBijlageForEntity'
import type { AssignedBijlage } from '../../types/AssignedBijlage'
import type { Bijlage } from '../../types/Bijlage'

interface Props {
  bijlage: Bijlage | AssignedBijlage
  entity: Entity
  onClose: () => void
}

const isAssignedBijlage = (bijlage: any): bijlage is AssignedBijlage =>
  bijlage && Object.keys(bijlage).includes('assignedTo')

export const Cancel = ({ bijlage, entity, onClose }: Props) => {
  const isAssigned = isAssignedBijlage(bijlage)

  const { mutate: cancelBijlageForEntity, error } = useCancelBijlageForEntity()

  const naam = isAssigned
    ? `${bijlage.documentsoort} ${bijlage.discipline}`
    : bijlage.naam

  const onClick = () => {
    cancelBijlageForEntity(
      {
        entity,
        bijlageInfo: bijlage,
        isAssigned,
      },
      {
        onSuccess: () => onClose(),
      },
    )
  }

  return (
    <>
      <DialogTitle>Annuleren bijlage</DialogTitle>
      <DialogContent>
        <StyledError error={error} />
        <DialogContentText>{`Weet u zeker dat u de bijlage ${naam} wilt annuleren?`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClick}>Ja</Button>
        <Button onClick={onClose}>Nee</Button>
      </DialogActions>
    </>
  )
}
